import { useEffect, useRef, useState } from "react";
import { ImplantCaseDetailsSection as ImplantCaseDetailsSectionLegacy } from "./ImplantCaseDetailsSection";

const getResolvedMissingTeethFlag = (orderCaseData) => {
  if (orderCaseData?.missingTeethSelectedTeeth?.length > 0) {
    return "Yes";
  }

  if (orderCaseData?.hasMissingTeeth !== undefined && orderCaseData?.hasMissingTeeth !== null) {
    if (orderCaseData?.hasMissingTeeth === true || orderCaseData?.hasMissingTeeth === "Yes") {
      return "Yes";
    }
    if (orderCaseData?.hasMissingTeeth === false || orderCaseData?.hasMissingTeeth === "No") {
      return "No";
    }
  }

  return "";
};

export const ImplantCaseDetailsSectionV2 = (props) => {
  const [hydratedOrderCaseData, setHydratedOrderCaseData] = useState(null);
  const hasHydratedDraftRef = useRef(false);
  const hydratedOrderIdRef = useRef(null);

  useEffect(() => {
    if (hydratedOrderIdRef.current !== props?.orderObjId) {
      hydratedOrderIdRef.current = props?.orderObjId || null;
      hasHydratedDraftRef.current = false;
      setHydratedOrderCaseData(null);
    }

    if (hasHydratedDraftRef.current) {
      return;
    }

    const hasIncomingDraft =
      (props?.orderCaseData?.services?.length || 0) > 0 ||
      (props?.orderCaseData?.missingTeethSelectedTeeth?.length || 0) > 0 ||
      props?.orderCaseData?.numberSystem !== undefined ||
      props?.orderCaseData?.hasMissingTeeth !== undefined;

    if (!hasIncomingDraft) {
      return;
    }

    const normalizedOrderCaseData = {
      ...(props?.orderCaseData ?? {}),
      hasMissingTeeth: getResolvedMissingTeethFlag(props?.orderCaseData),
      missingTeethSelectedTeeth:
        props?.orderCaseData?.missingTeethSelectedTeeth ||
        (props?.orderCaseData?.missingTeeth || [])?.reduce((acc, item) => {
          if (item?.expiryDate === null || item?.expiryDate === undefined) {
            acc.push(item?.teethno);
          }
          return acc;
        }, []),
    };

    setHydratedOrderCaseData(normalizedOrderCaseData);
    hasHydratedDraftRef.current = true;
  }, [props?.orderCaseData, props?.orderObjId]);

  const normalizedOrderCaseData = hydratedOrderCaseData || {
    ...(props?.orderCaseData ?? {}),
    hasMissingTeeth: getResolvedMissingTeethFlag(props?.orderCaseData),
    missingTeethSelectedTeeth:
      props?.orderCaseData?.missingTeethSelectedTeeth ||
      (props?.orderCaseData?.missingTeeth || [])?.reduce((acc, item) => {
        if (item?.expiryDate === null || item?.expiryDate === undefined) {
          acc.push(item?.teethno);
        }
        return acc;
      }, []),
  };

  return (
    <ImplantCaseDetailsSectionLegacy
      {...props}
      orderCaseData={normalizedOrderCaseData}
    />
  );
};

export default ImplantCaseDetailsSectionV2;
